module.exports = __webpack_public_path__ + "img/5.747383c9.jpg";